// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductPriceInput_root__14fuK","labeledInput":"ProductPriceInput_labeledInput__12RYz","checkbox":"ProductPriceInput_checkbox__24dHT"};